import { QueryClientProvider } from '@tanstack/react-query';
import { ReactNode } from 'react';
import { queryClient } from './queryClient';

// Re-exported so `queryClient` keeps ONE import site for consumers; it lives in a
// .ts module because non-React callers (the platform_call executor) are typechecked
// by a project with no `jsx` (packages/sdk/tsconfig.tests.json).
export { queryClient } from './queryClient';

export function QueryProvider({ children }: { children: ReactNode }) {
  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
}
